<template>
  <section class="page-panel record-photos">
    <header class="page-panel__header"><h3 class="panel-title">Fotografije</h3></header>
    <div class="page-panel__content grid-stack grid-row-gap-18">
      <div v-if="!readonly">
        <v-btn class="button button--secondary button--small" :disabled="disabled" type="button" variant="outlined" @click="fileInput?.click()">
          Odaberi datoteke
        </v-btn>
        <input ref="fileInput" :disabled="disabled" accept=".jpg,.jpeg,.png,.heic,image/jpeg,image/png,image/heic" multiple type="file" hidden @change="selectFiles" />
      </div>
      <div v-for="photo in savedPhotos" :key="photo.id" class="record-photos__row">
        <button class="record-photos__link" type="button" @click="$emit(preview ? 'preview' : 'download', photo)">{{ photo.fileName }}</button>
        <v-btn v-if="!readonly" aria-label="Ukloni fotografiju" :disabled="disabled" icon="mdi-close" size="x-small" variant="text" @click="$emit('remove-saved', photo.id)" />
      </div>
      <div v-for="(file, index) in pendingFiles" :key="`${file.name}-${index}`" class="record-photos__row">
        <span>{{ file.name }}</span>
        <v-btn v-if="!readonly" aria-label="Ukloni fotografiju" :disabled="disabled" icon="mdi-close" size="x-small" variant="text" @click="$emit('remove-pending', index)" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  savedPhotos: { type: Array, default: () => [] },
  pendingFiles: { type: Array, default: () => [] },
  readonly: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  preview: { type: Boolean, default: false },
})

const emit = defineEmits(['add-files', 'remove-saved', 'remove-pending', 'download', 'preview'])
const fileInput = ref(null)

function selectFiles (event) {
  emit('add-files', [...event.target.files])
  event.target.value = ''
}
</script>

<style scoped lang="scss">
.record-photos {
  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-wrap: anywhere;
  }

  &__link {
    padding: 0;
    background: none;
    color: var(--color-info-text);
    text-align: left;
    text-decoration: underline;
  }
}
</style>
